import styled from '@emotion/styled';

export const CommonParagraph = styled.div`
    font-family: ${({ theme }) => theme.typography.fontFamilies.primary};
    line-height: ${({ theme }) => theme.typography.lineHeights.body.medium};
    color: black;
    padding: 8px;
    max-width: 100%;
`;

export const HeaderLeft = styled(CommonParagraph)`
    font-size: 32px;
    padding-top: 32px;
    font-family: "Gotham";
    font-weight: ${({ theme }) => theme.typography.fontWeights.medium};
    color: ${({ theme }) => theme.colors.greyscale.gray40};
`;

export const HeaderSubmittedLeft = styled(CommonParagraph)`
    font-size: 32px;
    padding-bottom: 16px;
    font-family: "Gotham";
    font-weight: ${({ theme }) => theme.typography.fontWeights.medium};
    color: ${({ theme }) => theme.colors.greyscale.gray40};
`;

export const HeaderCenter = styled(CommonParagraph)`
    font-size: 32px;
    text-align: center;
    padding-top: 32px;
`;

export const CenterParagraph = styled(CommonParagraph)`
    text-align: center;
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: row;
`;

export const RightParagraph = styled(CommonParagraph)`
    text-align: right;
`;

export const HeaderWrapper = styled.div`
    display: flex;
    flex-direction: column;
`
export const HeaderRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`